const API_URL = {
  LOGIN: "auth/login",
  VERIFICATION: {
    LOGIN: "Identity/backoffice/login",
    REFRESH_TOKEN: "Identity/refreshToken",
    SEND_OTP: "Identity/sendOTP",
    VERIFY_OTP: "Identity/verifyOTP",
    REGISTER: "Identity/Verification/CreateVerificationUser",
    CHANGE_PASSWORD: "Identity/changePassword",
    CHANGE_USER_PASSWORD: "Identity/ChangeUserPassword",
    USER_PROFILE_DATA: "Identity/GetUserDetail",
    UPDATE_PROFILE: "Identity/UpdateProfile",
    GET_MODULE_RIGHT: "Identity/backoffice/GetUserModuleRights",
  },
  USER: {
    SLUG: "BackOffice/User",
    CREATE_USER: "BackOffice/user",
    PASSWORD_RESET: "BackOffice/user/resetPassword",
    GET_ASSIGNEE_USER: "verification/User/GetAllAssigneeUser",
    GET_RECRUITER_USER: "verification/User/GetAllRecruiters",
    GET_PICKER_USERS: "BackOffice/User/PickerUsers",
  },
  BRAND: {
    SLUG: "BackOffice/Brand",
    LOOKUP: "BackOffice/Brand/lookup",
  },
  TRANSPORTER: {
    SLUG: "BackOffice/Transporter",
    LOOKUP: "BackOffice/Transporter/lookup",
  },
  UNIT_OF_MEASUREMENT: {
    SLUG: "BackOffice/UnitOfMeasurement",
    LOOKUP: "BackOffice/UnitOfMeasurement/lookup",
  },
  UQC_MASTER: {
    SLUG: "BackOffice/UQCMaster",
    ACTIVE: "BackOffice/UQCMaster/active",
  },
  TENANT: {
    SLUG: "BackOffice/Tenant",
    SETTINGS: "BackOffice/TenantSettings",
    SETTINGS_V2: "Backoffice/Tenant/settings",
    SCAN_CONFIG: "BackOffice/TenantSettings/scan-config",
  },
  DOCUMENT_CODE_CONFIG: {
    GET: (documentType) => `BackOffice/DocumentNumber/config/${documentType}`,
    SAVE: (documentType) => `BackOffice/DocumentNumber/config/${documentType}`,
  },
  STATE: {
    SLUG: "BackOffice/State",
  },
  VENDOR: {
    SLUG: "BackOffice/Vendor",
    LOOKUP: "BackOffice/Vendor/lookup",
    ACTIVE: "BackOffice/Vendor/Active",
    ACTIVE_LOOKUP: "BackOffice/Vendor/active/lookup",
    DROPDOWN: "BackOffice/Vendor/active/dropdown",
    CONTACT: {
      SLUG: "BackOffice/VendorContactPerson",
      GET: "BackOffice/VendorContactPerson/vendor",
    },
    BANKING: {
      SLUG: "BackOffice/VendorBankDetail",
      GET: "BackOffice/VendorBankDetail/vendor",
    },
    ADDRESS: {
      SLUG: "BackOffice/VendorAddress",
      GET: "BackOffice/VendorAddress/vendor",
    },
  },
  WAREHOUSE: {
    SLUG: "BackOffice/Warehouse",
    LOOKUP: "BackOffice/Warehouse/lookup",
    ENABLE_BIN_MANAGEMENT: (id) =>
      `BackOffice/Warehouse/EnableBinManagement/${id}`,
    DISABLE_BIN_MANAGEMENT: (id) =>
      `BackOffice/Warehouse/DisableBinManagement/${id}`,
    TOGGLE_STATUS: (id) => `BackOffice/Warehouse/ToggleStatus/${id}`,
    BINS: (warehouseId) => `BackOffice/Warehouse/${warehouseId}/bins`,
    BINS_LOOKUP: (warehouseId) =>
      `BackOffice/Warehouse/${warehouseId}/bins/lookup`,
    DEFAULT: "BackOffice/Warehouse/Default",
    DEFAULT_LOOKUP: "BackOffice/Warehouse/Default/lookup",
  },
  CURRENCY: {
    SLUG: "BackOffice/Currency",
    LOOKUP: "BackOffice/Currency/lookup",
  },
  ROLE: {
    SLUG: "BackOffice/Role",
    ROLE_RIGHT_EDIT: "BackOffice/Role/RoleRights",
    ROLE_RIGHT_CREATE: "BackOffice/Role/GetModuleRights",
    GET_ROLE: "BackOffice/Role/Roles",
  },
  ITEM: {
    SLUG: "BackOffice/Item",
    LOOKUP: "BackOffice/Item/lookup",
    ACTIVE_ITEMS: "BackOffice/Item/ActiveItem",
    ACTIVE_ITEMS_LOOKUP: "BackOffice/Item/ActiveItem/lookup",
    ITEM_LOCATION: (itemId) =>
      `BackOffice/Item/${itemId}/location-availability`,
    CREATE_ITEM_LOCATION: "BackOffice/Item/Location",
    UPDATE_ITEM_LOCATION: "BackOffice/Item/Location",
    TRANSACTIONS: (itemId) => `BackOffice/Item/${itemId}/transactions`,
    BULK_IMPORT: "BackOffice/Item/bulk-import",
    BULK_IMPORT_TEMPLATE: "BackOffice/Item/bulk-import-template",
    BULK_IMPORT_HISTORY: "BackOffice/Item/bulk-import-history",
    BULK_IMPORT_DEFAULT_BINS: "BackOffice/Item/bulk-import-default-bins",
    BULK_IMPORT_DEFAULT_BINS_TEMPLATE: "BackOffice/Item/bulk-import-default-bins-template",
    BULK_IMPORT_DEFAULT_BINS_HISTORY: "BackOffice/Item/bulk-import-default-bins-history",
    EXPORT_EXCEL: "BackOffice/Item/export-excel",
  },
  ITEM_DEFAULT_BIN: {
    SEARCH: "BackOffice/ItemDefaultBin/search",
    PREVIEW_CHANGE: "BackOffice/ItemDefaultBin/preview-change",
    SET_DEFAULT: "BackOffice/ItemDefaultBin/set-default",
  },
  STOCK: {
    SUMMARY: "BackOffice/Stock/summary",
    ITEMS_STOCK_BY_LOCATION: "BackOffice/Stock/items-stock-by-location",
    // Hierarchical Stock View APIs
    HIERARCHY: {
      ITEM_SUMMARY: (itemId) => `BackOffice/Stock/hierarchy/item/${itemId}`,
      BY_LOCATION: (itemId) =>
        `BackOffice/Stock/hierarchy/item/${itemId}/locations`,
      BY_WAREHOUSE: (itemId, locationId) =>
        `BackOffice/Stock/hierarchy/item/${itemId}/location/${locationId}/warehouses`,
      BY_BIN: (itemId, warehouseId) =>
        `BackOffice/Stock/hierarchy/item/${itemId}/warehouse/${warehouseId}/bins`,
    },
    ITEM_WAREHOUSE: (itemId, warehouseId) =>
      `BackOffice/Stock/item/${itemId}/warehouse/${warehouseId}`,
  },
  OPENING_STOCK: {
    SLUG: "BackOffice/OpeningStock",
    BULK_IMPORT: "BackOffice/OpeningStock/bulk-import",
    BULK_IMPORT_TEMPLATE: "BackOffice/OpeningStock/bulk-import-template",
    BULK_IMPORT_HISTORY: "BackOffice/OpeningStock/bulk-import-history",
  },
  ITEM_GROUP: {
    SLUG: "BackOffice/ItemGroup",
    ADD_ITEM_GROUP: "BackOffice/ItemGroup/add-item",
    ADD_NEW_ITEM_TO_GROUP: "BackOffice/ItemGroup/add-new-item",
    REMOVE_ITEM_FROM_GROUP: "BackOffice/ItemGroup/remove-item",
    MOVE_ITEM_TO_ANOTHER_GROUP: "BackOffice/ItemGroup/move-item",
    GET_ATTRIBUTES: "BackOffice/ItemGroup/ItemGroupAttributes",
  },
  ITEM_CATEGORY: {
    SLUG: "BackOffice/ItemCategory",
    LOOKUP: "BackOffice/ItemCategory/lookup",
  },
  CUSTOMER_CATEGORY: {
    SLUG: "BackOffice/CustomerCategory",
    LOOKUP: "BackOffice/CustomerCategory/lookup",
  },
  CUSTOMER_ACCOUNT_TYPE: {
    SLUG: "BackOffice/CustomerAccountType",
    LOOKUP: "BackOffice/CustomerAccountType/lookup",
  },
  ITEM_SEGMENT: {
    SLUG: "BackOffice/ItemSegment",
    LOOKUP: "BackOffice/ItemSegment/lookup",
  },
  PRODUCT_GROUP_MASTER: {
    SLUG: "BackOffice/ProductGroup",
    LOOKUP: "BackOffice/ProductGroup/lookup",
  },
  TERRITORY: {
    SLUG: "BackOffice/Territory",
    LOOKUP: "BackOffice/Territory/lookup",
  },
  CUSTOMER: {
    SLUG: "BackOffice/Customer",
    ACTIVE: "BackOffice/Customer/Active",
    ACTIVE_LOOKUP: "BackOffice/Customer/active/lookup",
    ACTIVE_LIST: "BackOffice/Customer/active/list",
    ACTIVE_LIST_LOOKUP: "BackOffice/Customer/active/list/lookup",
    DROPDOWN: "BackOffice/Customer/active/dropdown",
    GET_NEXT_CUSTOMER_CODE: "BackOffice/DocumentNumber/next-customer-code",
    GET_SALES_PERSONS: "BackOffice/Customer/GetSalesPersons",
    ASSIGNED_SALES_PERSONS: "BackOffice/Customer/AssignedSalesPersons",
    REASSIGN_SALES_PERSON: "BackOffice/Customer/ReassignSalesPerson",
    EXPORT_EXCEL: "BackOffice/Customer/export-excel",
    CHECK_GST: "BackOffice/Customer/check-gst",
    CONTACT: {
      SLUG: "BackOffice/CustomerContactPerson",
      GET: "BackOffice/CustomerContactPerson/customer",
    },
    ADDRESS: {
      SLUG: "BackOffice/CustomerAddress",
      GET: "BackOffice/CustomerAddress/customer",
    },
  },
  PURCHASE_ORDER: {
    SLUG: "BackOffice/PurchaseOrder",
    GET_NEXT_PO_NUMBER: "BackOffice/DocumentNumber/next-po-number",
    GET_ITEMS: (id) => `BackOffice/PurchaseOrder/${id}/items`,
    SUBMIT_FOR_APPROVAL: "BackOffice/PurchaseOrder/SubmitForApproval",
    APPROVE: "BackOffice/PurchaseOrder/Approve",
    REJECT: "BackOffice/PurchaseOrder/Reject",
    MARK_AS_ISSUED: "BackOffice/PurchaseOrder/MarkAsIssued",
    MARK_AS_IN_TRANSIT: "BackOffice/PurchaseOrder/MarkAsInTransit",
    CANCEL: "BackOffice/PurchaseOrder/Cancel",
    REOPEN: "BackOffice/PurchaseOrder/Reopen",
    BULK_IMPORT: "BackOffice/PurchaseOrder/bulk-import",
    BULK_IMPORT_TEMPLATE: "BackOffice/PurchaseOrder/bulk-import-template",
    BULK_IMPORT_HISTORY: "BackOffice/PurchaseOrder/bulk-import-history",
    RESOLVE_ITEMS_FROM_FILE: "BackOffice/PurchaseOrder/resolve-items-from-file",
    FOR_RECEIVE: (id) => `BackOffice/PurchaseOrder/${id}/for-receive`,
    DROPDOWN: "BackOffice/PurchaseOrder/dropdown",
    DOWNLOAD_PDF: (id) => `Documents/PurchaseOrder/${id}`,
  },
  PURCHASE_RECEIVE: {
    SLUG: "BackOffice/PurchaseReceive",
    CREATE: "BackOffice/PurchaseReceive/create-purchase-receive",
    GET_NEXT_PR_NUMBER: "BackOffice/DocumentNumber/next-pr-number",
    UPDATE_INTRANSIT_TO_RECEIVED:
      "BackOffice/PurchaseReceive/update-intransit-to-received",
    DELETE: (id) => `BackOffice/PurchaseReceive/${id}`,
    BY_PURCHASE_ORDER: (purchaseOrderId) =>
      `BackOffice/PurchaseReceive/by-purchase-order/${purchaseOrderId}`,
    // QR Verification endpoints
    SCAN_QR_VERIFY: "BackOffice/PurchaseReceive/scan-qr-verify",
    REJECT_ITEM: "BackOffice/PurchaseReceive/reject-item",
    SHORTAGE_ITEM: "BackOffice/PurchaseReceive/shortage-item",
    REJECT_BOX_ITEM: "BackOffice/PurchaseReceive/reject-box-item",
    SHORTAGE_BOX_ITEM: "BackOffice/PurchaseReceive/shortage-box-item",
    COMPLETE_VERIFICATION: "BackOffice/PurchaseReceive/complete-verification",
    ITEM_BATCH_VERIFY: "BackOffice/PurchaseReceive/item-batch-verify",
    DOWNLOAD_PDF: (id) => `Documents/PurchaseReceive/${id}`,
    // Bulk Import endpoints
    BULK_IMPORT: "BackOffice/PurchaseReceive/bulk-import",
    BULK_IMPORT_HISTORY: "BackOffice/PurchaseReceive/import-history",
    BULK_IMPORT_STATUS: (importId) => `BackOffice/PurchaseReceive/import-status/${importId}`,
    // Box Scanning & Invoice endpoints
    BOX_PROGRESS: (id) => `BackOffice/PurchaseReceive/${id}/box-progress`,
    BATCH_SCAN_UPDATE: "BackOffice/PurchaseReceive/batch-scan-update",
    BY_INVOICE: "BackOffice/PurchaseReceive/by-invoice",
    MARK_INVOICE_RECEIVED: "BackOffice/PurchaseReceive/mark-invoice-received",
    AVAILABLE_BINS: (id) => `BackOffice/PurchaseReceive/${id}/available-bins`,
    INVOICE_AVAILABLE_BINS: (invoiceNumber) =>
      `BackOffice/PurchaseReceive/invoice-available-bins?invoiceNumber=${encodeURIComponent(invoiceNumber)}`,
    RECEIVE_BATCH: "BackOffice/PurchaseReceive/receive-batch",
    INVOICE_DETAIL: (invoiceNumber) =>
      `BackOffice/PurchaseReceive/invoice-detail?invoiceNumber=${encodeURIComponent(invoiceNumber)}`,
    // Invoice-level verification endpoints
    INVOICE_VERIFICATION_PROGRESS: (invoiceNumber) =>
      `BackOffice/PurchaseReceive/invoice-verification-progress?invoiceNumber=${encodeURIComponent(invoiceNumber)}`,
    INVOICE_BATCH_SCAN_UPDATE:
      "BackOffice/PurchaseReceive/invoice-batch-scan-update",
    INVOICE_BATCH_SCAN_UPDATE_V2:
      "BackOffice/PurchaseReceive/invoice-batch-scan-update-v2",
    INVOICE_REJECT_BOX_ITEM:
      "BackOffice/PurchaseReceive/invoice-reject-box-item",
    INVOICE_SHORTAGE_BOX_ITEM:
      "BackOffice/PurchaseReceive/invoice-shortage-box-item",
    INVOICE_MARK_BOX_MISSING:
      "BackOffice/PurchaseReceive/invoice-mark-box-missing",
    COMPLETE_INVOICE_VERIFICATION:
      "BackOffice/PurchaseReceive/complete-invoice-verification",
    // Invoice-wise Receiving (Box Scanning at Receiving Stage)
    START_INVOICE_RECEIVING:
      "BackOffice/PurchaseReceive/start-invoice-receiving",
    COMPLETE_INVOICE_RECEIVING:
      "BackOffice/PurchaseReceive/complete-invoice-receiving",
    INVOICE_DEFAULT_BIN_CHECK: (invoiceNumber) =>
      `BackOffice/PurchaseReceive/invoice-default-bin-check?invoiceNumber=${encodeURIComponent(invoiceNumber)}`,
    SET_INVOICE_DEFAULT_BINS:
      "BackOffice/PurchaseReceive/set-invoice-default-bins",
  },
  // Multi-Invoice Batch Receive (session-based)
  RECEIVE_SESSION: {
    SLUG: "BackOffice/ReceiveSession",
    LOOKUP_PRS: "BackOffice/ReceiveSession/lookup-prs",
    START: "BackOffice/ReceiveSession/start",
    LIST: "BackOffice/ReceiveSession/list",
    JOIN: (id) => `BackOffice/ReceiveSession/${id}/join`,
    DETAIL: (id) => `BackOffice/ReceiveSession/${id}`,
    PROGRESS: (id) => `BackOffice/ReceiveSession/${id}/progress`,
    ADD_PRS: "BackOffice/ReceiveSession/add-prs",
    REMOVE_PR: "BackOffice/ReceiveSession/remove-pr",
    SCAN: "BackOffice/ReceiveSession/scan",
    FINALIZE_MARK_MISSING: "BackOffice/ReceiveSession/finalize-mark-missing",
    CLOSE: (id) => `BackOffice/ReceiveSession/${id}/close`,
    RESET: (id) => `BackOffice/ReceiveSession/${id}/reset`,
    CANCEL: (id) => `BackOffice/ReceiveSession/${id}/cancel`,
  },
  LOCATION: {
    SLUG: "BackOffice/Location",
    ACCESSIBLE_LOCATIONS: "BackOffice/Location/AccessibleLocations",
    ACCESSIBLE_LOCATIONS_LOOKUP: "BackOffice/Location/AccessibleLocations/lookup",
    ACTIVE_LOCATIONS: "BackOffice/Location/Active",
    ACTIVE_LOCATIONS_LOOKUP: "BackOffice/Location/Active/lookup",
    DELIVERY_ADDRESSES: (locationId) =>
      `BackOffice/Location/DeliveryAddresses/${locationId}`,
    DELIVERY_ADDRESSES_LOOKUP: (locationId) =>
      `BackOffice/Location/DeliveryAddresses/${locationId}/lookup`,
    TOGGLE_STATUS: (id) => `BackOffice/Location/ToggleStatus/${id}`,
    DEFAULT: "BackOffice/Location/Default",
    DEFAULT_LOOKUP: "BackOffice/Location/Default/lookup",
  },
  LOCATION_ACCESS: {
    ADD_USERS: "BackOffice/LocationAccess/AddUsersToLocation",
    REMOVE_USER: "BackOffice/LocationAccess/RemoveUserFromLocation",
    GET_USERS_BY_LOCATION: (locationId) =>
      `BackOffice/LocationAccess/GetUsersByLocation/${locationId}`,
    GET_AVAILABLE_USERS: (locationId) =>
      `BackOffice/LocationAccess/GetAvailableUsersForLocation/${locationId}`,
  },
  ZONE: {
    SLUG: "BackOffice/Zone",
    BY_WAREHOUSE: (warehouseId) => `BackOffice/Zone/warehouse/${warehouseId}`,
    INITIALIZE: (warehouseId) => `BackOffice/Zone/initialize/${warehouseId}`,
  },
  BIN: {
    SLUG: "BackOffice/Bins",
    BY_ZONE: (zoneId) => `BackOffice/Bins/zone/${zoneId}`,
    BY_WAREHOUSE: "BackOffice/Bins/warehouse/lookup",
    BULK_IMPORT_FILE: "BackOffice/Bins/BulkImport/File",
  },
  COUNTRY: {
    SLUG: "BackOffice/Country",
  },
  MANUFACTURER: {
    SLUG: "BackOffice/Manufacturer",
    LOOKUP: "BackOffice/Manufacturer/lookup",
  },
  APPROVER: {
    PURCHASE_ORDER: {
      SLUG: "BackOffice/Approver/PurchaseOrder",
    },
    SALES_ORDER: {
      SLUG: "BackOffice/Approver/SalesOrder",
    },
  },
  QUOTATION: {
    SLUG: "BackOffice/Quotation",
    GET_NEXT_QUOTATION_NUMBER: "BackOffice/DocumentNumber/next-quotation-number",
    GET_DETAIL: (id) => `BackOffice/Quotation/${id}/detail`,
    GET_VERSION: (id, versionId) => `BackOffice/Quotation/${id}/versions/${versionId}`,
    SEND: (id) => `BackOffice/Quotation/${id}/send`,
    ACCEPT: (id) => `BackOffice/Quotation/${id}/accept`,
    REJECT: (id) => `BackOffice/Quotation/${id}/reject`,
    CANCEL: (id) => `BackOffice/Quotation/${id}/cancel`,
    REVISE: (id) => `BackOffice/Quotation/${id}/revise`,
    SO_PREVIEW: (id) => `BackOffice/Quotation/${id}/so-preview`,
    DOWNLOAD_PDF: (id, versionId = null, templateVersion = "v1") =>
      versionId
        ? `Documents/Quotation/${id}?versionId=${versionId}&templateVersion=${templateVersion}`
        : `Documents/Quotation/${id}?templateVersion=${templateVersion}`,
    EXPORT_EXCEL: (id) => `BackOffice/Quotation/${id}/export-excel`,
    RESOLVE_ITEMS_FROM_FILE: "BackOffice/Quotation/resolve-items-from-file",
  },
  SALES_ORDER: {
    SLUG: "BackOffice/SalesOrder",
    GET_NEXT_SO_NUMBER: "BackOffice/DocumentNumber/next-so-number",
    GET_ITEMS: (id) => `BackOffice/SalesOrder/${id}/items`,
    GET_CANCELLED_ITEMS: (id) => `BackOffice/SalesOrder/${id}/cancelled-items`,
    GET_SALES_PERSONS: "BackOffice/SalesOrder/GetSalesPersons",
    GET_SALES_PERSONS_LOOKUP: "BackOffice/SalesOrder/lookup/salespersons",
    GET_ORGANISATION_USERS: "BackOffice/SalesOrder/GetOrganisationUsers",
    SUBMIT_FOR_APPROVAL: "BackOffice/SalesOrder/SubmitForApproval",
    APPROVE: "BackOffice/SalesOrder/Approve",
    REJECT: "BackOffice/SalesOrder/Reject",
    CONFIRM: "BackOffice/SalesOrder/Confirm",
    CANCEL: "BackOffice/SalesOrder/Cancel",
    REOPEN: "BackOffice/SalesOrder/Reopen",
    DROPDOWN: "BackOffice/SalesOrder/dropdown",
    RETURN_ELIGIBLE: "BackOffice/SalesOrder/return-eligible",
    CUSTOMER_ITEM_INVOICE_HISTORY: "BackOffice/SalesOrder/customer-item-invoice-history",
    PACKAGE_ELIGIBLE: "BackOffice/SalesOrder/package-eligible",
    CANCEL_PREVIEW: (id) => `BackOffice/SalesOrder/${id}/cancel-preview`,
    CANCEL_ITEMS: (id) => `BackOffice/SalesOrder/${id}/cancel`,
    VOID: (id) => `BackOffice/SalesOrder/${id}/void`,
    CLOSE: (id) => `BackOffice/SalesOrder/${id}/close`,
    // Packing items - item-level data for packing workflow
    // packageId is optional - when provided, includes items packed in that package even if fully packed elsewhere
    GET_PACKING_ITEMS: (salesOrderId, packageId = null) =>
      packageId
        ? `BackOffice/SalesOrder/${salesOrderId}/packing-items?packageId=${packageId}`
        : `BackOffice/SalesOrder/${salesOrderId}/packing-items`,
    BULK_IMPORT: "BackOffice/SalesOrder/bulk-import",
    BULK_IMPORT_TEMPLATE: "BackOffice/SalesOrder/bulk-import-template",
    BULK_IMPORT_HISTORY: "BackOffice/SalesOrder/bulk-import-history",
    // Resolve a SKU/Quantity spreadsheet into priced grid line items (stateless,
    // synchronous — does NOT create orders, unlike BULK_IMPORT above).
    RESOLVE_ITEMS_FROM_FILE: "BackOffice/SalesOrder/resolve-items-from-file",
    // PDF download — DocumentRendering API. Returns application/pdf when the
    // Accept header asks for it. Ocelot routes Documents/SalesOrder/* to
    // /api/v1/SalesOrder/* on the DocumentRendering host (same convention as
    // Invoice / PurchaseOrder / PurchaseReceive).
    DOWNLOAD_PDF: (id, templateVersion = "v1") =>
      `Documents/SalesOrder/${id}?templateVersion=${templateVersion}`,
    // Excel export — BackOffice API. Returns an .xlsx whose layout mirrors the
    // Sales Order PDF (same convention as Invoice's export-excel endpoint).
    EXPORT_EXCEL: (id) => `BackOffice/SalesOrder/${id}/export-excel`,
  },
  COUNTER_SALE: {
    SLUG: "BackOffice/CounterSale",
    NEXT_NUMBER: "BackOffice/CounterSale/next-number",
    DRAFT: "BackOffice/CounterSale/draft",
    POST: (id) => `BackOffice/CounterSale/${id}/post`,
    UPDATE_POSTED: (id) => `BackOffice/CounterSale/${id}`,
    CANCEL: (id) => `BackOffice/CounterSale/${id}/cancel`,
    DOWNLOAD_PDF: (id) => `Documents/CounterSale/${id}`,
  },
  PAYMENT_TERMS: {
    SLUG: "BackOffice/PaymentTerms",
    ACTIVE: "BackOffice/PaymentTerms",
  },
  INVOICE: {
    SLUG: "BackOffice/Invoice",
    LIST: "BackOffice/Invoice",
    PENDING_SALES_ORDERS: "BackOffice/Invoice/pending-sales-orders",
    PREVIEW: (salesOrderId, shipmentId) =>
      `BackOffice/SalesOrder/${salesOrderId}/invoice-preview?shipmentId=${shipmentId}`,
    PREVIEW_BY_DC: (salesOrderId, deliveryChallanId) =>
      `BackOffice/SalesOrder/${salesOrderId}/invoice-preview?deliveryChallanId=${deliveryChallanId}`,
    CREATE: "BackOffice/Invoice",
    UPDATE: "BackOffice/Invoice",
    UPDATE_STATUS: "BackOffice/Invoice/status",
    CANCEL_WITH_EINVOICE: (invoiceId) =>
      `BackOffice/Invoice/${invoiceId}/cancel-with-einvoice`,
    GET_NEXT_INVOICE_NUMBER: "BackOffice/DocumentNumber/next-invoice-number",
    GET_BY_ID: (invoiceId) => `BackOffice/Invoice/${invoiceId}`,
    GET_FOR_EDIT: (invoiceId) => `BackOffice/Invoice/${invoiceId}/edit`,
    GET_ITEMS: (invoiceId) => `BackOffice/Invoice/${invoiceId}/items`,

    GET_PENDING_STATUS: (salesOrderId) =>
      `BackOffice/Invoice/pending-status/${salesOrderId}`,
    GET_PAYMENT_SUMMARY: (invoiceId) =>
      `BackOffice/Invoice/${invoiceId}/payment-summary`,
    GET_PAYMENTS: (invoiceId) => `BackOffice/Invoice/${invoiceId}/payments`,
    GET_TRANSACTION_HISTORY: (invoiceId) =>
      `BackOffice/Invoice/${invoiceId}/transaction-history`,
    GET_RECORD_PAYMENT_INFO: (invoiceId) =>
      `BackOffice/Invoice/${invoiceId}/record-payment`,
    RECORD_PAYMENT: "BackOffice/Invoice/payment",
    GET_NEXT_PAYMENT_NUMBER: "BackOffice/DocumentNumber/next-payment-number",
    GET_WRITE_OFF_DETAILS: (invoiceId) =>
      `BackOffice/Invoice/${invoiceId}/write-off-details`,
    WRITE_OFF: "BackOffice/Invoice/write-off",
    GET_NEXT_WRITEOFF_NUMBER: "BackOffice/DocumentNumber/next-writeoff-number",
    DOWNLOAD_PDF: (invoiceId, templateVersion = "v1") =>
      `Documents/Invoice/${invoiceId}?templateVersion=${templateVersion}`,
    EXPORT_EXCEL: (invoiceId) =>
      `BackOffice/Invoice/${invoiceId}/export-excel`,
    INVOICE_ELIGIBLE_SALES_ORDERS: "BackOffice/SalesOrder/invoice-eligible",
    BY_SALES_ORDER: (salesOrderId) =>
      `BackOffice/Invoice/by-salesorder/${salesOrderId}`,
    FILTER_OPTIONS_BY_CUSTOMER: "BackOffice/Invoice/filter-options-by-customer",
    PREVIEW_MULTI: "BackOffice/Invoice/preview-multi",
    ELIGIBLE_DCS_BY_CUSTOMER: "BackOffice/Invoice/eligible-dcs",
    ELIGIBLE_SHIPMENTS_BY_CUSTOMER: "BackOffice/Invoice/eligible-shipments",
    MRP_VARIANTS: "BackOffice/Invoice/mrp-variants",
  },
  EINVOICE: {
    GENERATE: (salesInvoiceId) => `BackOffice/EInvoice/generate/${salesInvoiceId}`,
    CANCEL: (salesInvoiceId) => `BackOffice/EInvoice/cancel/${salesInvoiceId}`,
    RETRY: (salesInvoiceId) => `BackOffice/EInvoice/retry/${salesInvoiceId}`,
    GENERATE_EWAYBILL: (salesInvoiceId) => `BackOffice/EInvoice/ewaybill/generate/${salesInvoiceId}`,
    CANCEL_EWAYBILL: (eWayBillRecordId) => `BackOffice/EInvoice/ewaybill/cancel/${eWayBillRecordId}`,
    UPDATE_VEHICLE: (eWayBillRecordId) => `BackOffice/EInvoice/ewaybill/update-vehicle/${eWayBillRecordId}`,
    EXTEND_VALIDITY: (eWayBillRecordId) => `BackOffice/EInvoice/ewaybill/extend-validity/${eWayBillRecordId}`,
    // Combined single-call endpoints (plan §22, §13)
    GENERATE_WITH_EWAYBILL: (salesInvoiceId) => `BackOffice/EInvoice/generate-with-ewaybill/${salesInvoiceId}`,
    CANCEL_WITH_EWAYBILL: (salesInvoiceId) => `BackOffice/EInvoice/cancel-with-ewaybill/${salesInvoiceId}`,
    // Counter Sale routes (Phase 2). Mirror the Invoice surface but keyed by
    // CounterSaleId. Same EWB modal endpoints (generate/cancel/update-vehicle/
    // extend-validity) are shared — they take an EWayBillRecordId, which is
    // source-doc-agnostic.
    CS_GENERATE: (counterSaleId) => `BackOffice/EInvoice/counter-sale/generate/${counterSaleId}`,
    CS_CANCEL: (counterSaleId) => `BackOffice/EInvoice/counter-sale/cancel/${counterSaleId}`,
    CS_GENERATE_WITH_EWAYBILL: (counterSaleId) => `BackOffice/EInvoice/counter-sale/generate-with-ewaybill/${counterSaleId}`,
    CS_GENERATE_EWAYBILL: (counterSaleId) => `BackOffice/EInvoice/counter-sale/ewaybill/generate/${counterSaleId}`,
  },
  HISTORY: {
    SLUG: "BackOffice/history",
  },
  FISCAL_CALENDAR: {
    SLUG: "BackOffice/FiscalCalendar",
    ACTIVE: "BackOffice/FiscalCalendar/active",
    ACTIVE_LOOKUP: "BackOffice/FiscalCalendar/active/lookup",
    CLOSE: (id) => `BackOffice/FiscalCalendar/${id}/close`,
  },
  IMPORT_TEMPLATE: {
    SLUG: "BackOffice/ImportTemplate",
    LIST: "BackOffice/ImportTemplate/list",
    BY_ENTITY: (entityType) => `BackOffice/ImportTemplate/by-entity/${entityType}`,
    DEFAULT: (entityType) => `BackOffice/ImportTemplate/default/${entityType}`,
    SET_DEFAULT: (id) => `BackOffice/ImportTemplate/${id}/set-default`,
    CLONE: (id) => `BackOffice/ImportTemplate/${id}/clone`,
    IMPORTABLE_FIELDS: (entityType) => `BackOffice/ImportTemplate/importable-fields/${entityType}`,
    IMPORTABLE_FIELDS_GROUPED: (entityType) => `BackOffice/ImportTemplate/importable-fields/${entityType}/grouped`,
    SUPPORTED_FORMATS: "BackOffice/ImportTemplate/supported-formats",
  },
  PICKLIST: {
    SLUG: "BackOffice/Picklist",
    GET_NEXT_PICKLIST_NUMBER: "BackOffice/DocumentNumber/next-picklist-number",
    GET_ITEMS: (id) => `BackOffice/Picklist/${id}/items`,
    PREPARE: "BackOffice/Picklist/prepare",
    START_PICKING: (id) => `BackOffice/Picklist/${id}/start`,
    PICK: (id) => `BackOffice/Picklist/${id}/pick`,
    CANCEL: (id) => `BackOffice/Picklist/${id}/cancel`,
    DROPDOWN: "BackOffice/Picklist/dropdown",
    ELIGIBLE_SALES_ORDERS: "BackOffice/Picklist/eligible-sales-orders",
    PENDING_SALES_ORDERS: "BackOffice/Picklist/pending-sales-orders",
    BY_SALES_ORDER: (salesOrderId) =>
      `BackOffice/Picklist/by-sales-order/${salesOrderId}`,
    PRINT: (id) => `Documents/Picklist/${id}`,
  },
  TENANT_EMAIL_CONFIGURATION: {
    SLUG: "BackOffice/TenantEmailConfiguration",
    SET_DEFAULT: "BackOffice/TenantEmailConfiguration/:id/set-default",
  },
  TENANT_EMAIL_TEMPLATE: {
    SLUG: "BackOffice/TenantEmailTemplate",
    DETAIL: "BackOffice/TenantEmailTemplate/details",
    SAVE: "BackOffice/TenantEmailTemplate/save",
    RESET: "BackOffice/TenantEmailTemplate/reset",
  },
  PACKAGE: {
    SLUG: "BackOffice/package",
    LIST: "BackOffice/package",
    CREATE: "BackOffice/package",
    GET_NEXT_PSN_NUMBER: "BackOffice/DocumentNumber/next-psn-number",
    AGGREGATED: (packageId) => `BackOffice/package/${packageId}/aggregated`,
    COMPLETE: (packageId) => `BackOffice/package/${packageId}/complete`,
    CANCEL: (packageId) => `BackOffice/package/${packageId}/cancel`,
    // Full package details (for details panel)
    FULL: (packageId) => `BackOffice/package/${packageId}/full`,
    // Direct package packing (without box)
    GET_ITEMS: (packageId) => `BackOffice/package/${packageId}/items`,
    ADD_ITEM: (packageId) => `BackOffice/package/${packageId}/items`,
    REMOVE_ITEM: (packageId, packedItemId) =>
      `BackOffice/package/${packageId}/items/${packedItemId}`,
    // MRP-only correction of already-packed box items (Draft or Packed, pre-invoice)
    UPDATE_BOX_ITEM_MRP: (packageId) =>
      `BackOffice/package/${packageId}/box-item-mrp`,
    SCAN: (packageId) => `BackOffice/package/${packageId}/scan`,
    // Packages by Sales Order (for SO detail related records)
    BY_SALES_ORDER: (salesOrderId) =>
      `BackOffice/package/by-sales-order/${salesOrderId}`,
    PENDING_SALES_ORDERS: "BackOffice/package/pending-sales-orders",
  },
  // Scan endpoints (Server-Side Packing Mode)
  SCAN: {
    BATCH: "BackOffice/package/scan/batch",
  },
  BOX: {
    BY_PACKAGE: (packageId) => `BackOffice/box/package/${packageId}`,
    CREATE: (packageId) => `BackOffice/box/package/${packageId}`,
    CLOSE: (boxId) => `BackOffice/box/${boxId}/close`,
    DELETE: (boxId) => `BackOffice/box/${boxId}`,
    GET_DETAIL: (boxId) => `BackOffice/box/${boxId}`,
    ADD_ITEMS: (boxId) => `BackOffice/box/${boxId}/items`,
    REMOVE_ITEM: (boxId, boxItemId) =>
      `BackOffice/box/${boxId}/items/${boxItemId}`,
    REMOVE_ITEMS_BY_ITEM: (boxId, itemId) =>
      `BackOffice/box/${boxId}/items/by-item/${itemId}`,
    SCAN: (boxId, packageId) =>
      `BackOffice/box/${boxId}/package/${packageId}/scan`,
  },
  DELIVERY_CHALLAN: {
    SLUG: "BackOffice/DeliveryChallan",
    SALES_ORDERS_BY_CUSTOMER: (customerId) =>
      `BackOffice/DeliveryChallan/salesorders/${customerId}`,
    ELIGIBLE_PACKAGES: (salesOrderId, excludeDCId) =>
      `BackOffice/DeliveryChallan/eligible-packages/${salesOrderId}${excludeDCId ? `?excludeDCId=${excludeDCId}` : ""}`,
    CREATION_ELIGIBILITY: (salesOrderId) =>
      `BackOffice/DeliveryChallan/creation-eligibility/${salesOrderId}`,
    PENDING_SALES_ORDERS: "BackOffice/DeliveryChallan/pending-sales-orders",
    CONFIRM: (id) => `BackOffice/DeliveryChallan/${id}/confirm`,
    DISPATCH: (id) => `BackOffice/DeliveryChallan/${id}/dispatch`,
    CLOSE: (id) => `BackOffice/DeliveryChallan/${id}/close`,
    CANCEL: (id) => `BackOffice/DeliveryChallan/${id}/cancel`,
    ELIGIBLE_FOR_SHIPMENT: (customerId) =>
      `BackOffice/DeliveryChallan/eligible-for-shipment/${customerId}`,
    BY_SALES_ORDER: (salesOrderId) =>
      `BackOffice/DeliveryChallan/by-salesorder/${salesOrderId}`,
    BY_CUSTOMER: (customerId) =>
      `BackOffice/DeliveryChallan/by-customer/${customerId}`,
    ELIGIBLE_FOR_INVOICE: (salesOrderId) =>
      `BackOffice/DeliveryChallan/eligible-for-invoice/${salesOrderId}`,
  },
  SHIPMENT: {
    SLUG: "BackOffice/Shipment",
    PENDING_SALES_ORDERS: "BackOffice/Shipment/pending-sales-orders",
    SALES_ORDERS_BY_CUSTOMER: (customerId) =>
      `BackOffice/Shipment/salesorders/${customerId}`,
    DELIVERY_CHALLANS_BY_CUSTOMER: (customerId, shipmentId) =>
      `BackOffice/Shipment/delivery-challans/${customerId}${shipmentId ? `?shipmentId=${shipmentId}` : ""}`,
    DISPATCH: (id) => `BackOffice/Shipment/${id}/dispatch`,
    DELIVER: (id) => `BackOffice/Shipment/${id}/deliver`,
    ELIGIBLE_FOR_INVOICE: (salesOrderId) =>
      `BackOffice/Shipment/eligible/${salesOrderId}`,
    CREATION_ELIGIBILITY: (salesOrderId) =>
      `BackOffice/Shipment/creation-eligibility/${salesOrderId}`,
    BY_SALES_ORDER: (salesOrderId) =>
      `BackOffice/Shipment/by-salesorder/${salesOrderId}`,
    CANCEL: "BackOffice/Shipment/cancel",
  },
  SALES_RETURN: {
    SLUG: "BackOffice/SalesReturn",
    GET_ITEMS: (id) => `BackOffice/SalesReturn/${id}/items`,
    APPROVE: (id) => `BackOffice/SalesReturn/${id}/approve`,
    PREPARE: "BackOffice/SalesReturn/prepare",
    PREPARE_APPROVAL: (id) => `BackOffice/SalesReturn/${id}/prepare-approval`,
    ELIGIBLE_INVOICES: (salesOrderId) =>
      `BackOffice/Invoice/sales-order/${salesOrderId}/sales-return-eligible`,
    GET_NEXT_RMA_NUMBER: "BackOffice/DocumentNumber/next-rma-number",
    BY_SALES_ORDER: (salesOrderId) =>
      `BackOffice/SalesReturn/by-sales-order/${salesOrderId}`,
    DOWNLOAD_DOCUMENT: (documentId) =>
      `BackOffice/SalesReturn/documents/${documentId}/download`,
  },
  STOCK_ADJUSTMENT: {
    SLUG: "Backoffice/StockAdjustment",
    REASONS: "Backoffice/StockAdjustment/reasons",
    FULL: "Backoffice/StockAdjustment/full",
    FULL_UPDATE: (id) => `Backoffice/StockAdjustment/${id}/full`,
    // Value Adjustment endpoints (cost changes without quantity changes)
    VALUE_FULL: "Backoffice/StockAdjustment/value/full",
    VALUE_FULL_UPDATE: (id) => `Backoffice/StockAdjustment/${id}/value/full`,
    ITEMS: (id) => `Backoffice/StockAdjustment/${id}/items`,
    DELETE_ITEM: (id, itemId) =>
      `Backoffice/StockAdjustment/${id}/items/${itemId}`,
    SUBMIT: (id) => `Backoffice/StockAdjustment/${id}/submit`,
    APPROVE: (id) => `Backoffice/StockAdjustment/${id}/approve`,
    REJECT: (id) => `Backoffice/StockAdjustment/${id}/reject`,
    CANCEL: (id) => `Backoffice/StockAdjustment/${id}/cancel`,
    POST: (id) => `Backoffice/StockAdjustment/${id}/post`,
    GET_NEXT_ADJUSTMENT_NUMBER:
      "BackOffice/DocumentNumber/next-adjustment-number",
    STOCK_BREAKDOWN: "Backoffice/StockAdjustment/stock-breakdown",
    BULK_IMPORT: "Backoffice/StockAdjustment/bulk-import",
    BULK_IMPORT_TEMPLATE: "Backoffice/StockAdjustment/bulk-import-template",
    BULK_IMPORT_HISTORY: "Backoffice/StockAdjustment/bulk-import-history",
  },
  TRANSFER_ORDER: {
    SLUG: "Backoffice/TransferOrder",
    FULL: "Backoffice/TransferOrder",
    FULL_UPDATE: (id) => `Backoffice/TransferOrder/${id}`,
    SHIP: (id) => `Backoffice/TransferOrder/${id}/ship`,
    COMPLETE: (id) => `Backoffice/TransferOrder/${id}/complete`,
    CANCEL: (id) => `Backoffice/TransferOrder/${id}/cancel`,
    GET_NEXT_TRANSFER_NUMBER: "BackOffice/DocumentNumber/next-transfer-number",
    STOCK_AVAILABLE: "Backoffice/TransferOrder/stock-available",
    // New unified location APIs
    TRANSFER_LOCATIONS: "Backoffice/TransferOrder/transfer-locations",
    SOURCE_STOCK_BREAKDOWN: "Backoffice/TransferOrder/source-stock-breakdown",
    DESTINATION_BINS: "Backoffice/TransferOrder/destination-bins",
  },
  BACKORDER: {
    SLUG: "BackOffice/Backorder",
    GET_NEXT_BACKORDER_NUMBER:
      "BackOffice/DocumentNumber/next-backorder-number",
    GET_ITEMS: (id) => `BackOffice/Backorder/${id}/items`,
    GET_BY_SALES_ORDER: (salesOrderId) =>
      `BackOffice/Backorder/by-sales-order/${salesOrderId}`,
    CLOSE: (id) => `BackOffice/Backorder/${id}/close`,
    UPDATE_ITEM: (id, itemId) => `BackOffice/Backorder/${id}/items/${itemId}`,
    // Backorder availability for creation (from Sales Order)
    AVAILABILITY: (salesOrderId) =>
      `BackOffice/SalesOrder/${salesOrderId}/backorder-availability`,
    // Fulfill backorders endpoints
    FULFILL_ITEMS: "BackOffice/Backorder/fulfill-items",
    CREATE_PICKLIST: "BackOffice/Backorder/create-picklist",
    // Attention check - alerts when backorder qty is insufficient
    ATTENTION_CHECK: (salesOrderId) =>
      `BackOffice/Backorder/attention-check/${salesOrderId}`,
    // Multi-view aggregated endpoints
    BY_SKU: "BackOffice/Backorder/by-sku",
    BY_CUSTOMER: "BackOffice/Backorder/by-customer",
    GROUPED_BY_SALES_ORDER: "BackOffice/Backorder/grouped-by-sales-order",
    // Export to Excel (one per list tab)
    EXPORT_EXCEL: "BackOffice/Backorder/export-excel",
    EXPORT_EXCEL_BY_SKU: "BackOffice/Backorder/by-sku/export-excel",
    EXPORT_EXCEL_BY_CUSTOMER: "BackOffice/Backorder/by-customer/export-excel",
    EXPORT_EXCEL_BY_SALES_ORDER:
      "BackOffice/Backorder/grouped-by-sales-order/export-excel",
  },
  SALES_CREDIT_NOTE: {
    SLUG: "BackOffice/SalesCreditNote",
    LIST: "BackOffice/SalesCreditNote",
    CREATE: "BackOffice/SalesCreditNote",
    UPDATE: "BackOffice/SalesCreditNote",
    GET_BY_ID: (id) => `BackOffice/SalesCreditNote/${id}`,
    PREPARATION: "BackOffice/SalesCreditNote/preparation",
    PREPARATION_LEGACY: "BackOffice/SalesCreditNote/preparation-legacy",
    UPDATE_STATUS: "BackOffice/SalesCreditNote/status",
    GET_NEXT_CREDIT_NOTE_NUMBER:
      "BackOffice/DocumentNumber/next-creditnote-number",
    BY_INVOICE: (invoiceId) =>
      `BackOffice/SalesCreditNote/by-invoice/${invoiceId}`,
    SUMMARY_BY_INVOICE: (invoiceId) =>
      `BackOffice/SalesCreditNote/summary-by-invoice/${invoiceId}`,
    DOWNLOAD_DOCUMENT: (documentId) =>
      `BackOffice/SalesCreditNote/documents/${documentId}/download`,
    GENERATE_EINVOICE: (id) =>
      `BackOffice/SalesCreditNote/${id}/generate-einvoice`,
    DOWNLOAD_PDF: (creditNoteId, templateVersion = "v1") =>
      `Documents/CreditNote/${creditNoteId}?templateVersion=${templateVersion}`,
  },
  // ============================================
  // Report Module Endpoints
  // ============================================
  DASHBOARD: {
    KPIS: "BackOffice/Dashboard/kpis",
    SALES_ORDER_SUMMARY: "BackOffice/Dashboard/sales-order-summary",
    FUNNEL: "BackOffice/Dashboard/funnel",
    TOP_SELLING_ITEMS: "BackOffice/Dashboard/rankings/top-selling-items",
    TOP_LOCATIONS: "BackOffice/Dashboard/rankings/top-locations",
    TOP_CUSTOMERS: "BackOffice/Dashboard/rankings/top-customers",
    TOP_VENDORS: "BackOffice/Dashboard/rankings/top-vendors",
    TOP_SALES_REPS: "BackOffice/Dashboard/rankings/top-sales-reps",
    REORDER: "BackOffice/Dashboard/inventory/reorder",
    STOCK_BY_WAREHOUSE: "BackOffice/Dashboard/inventory/stock-by-warehouse",
    DEAD_STOCK: "BackOffice/Dashboard/inventory/dead-stock",
    REFRESH: "BackOffice/Dashboard/refresh",
  },
  // ============================================
  STOCK_REPORT: {
    STOCK_SUMMARY: "BackOffice/StockReport/stock-summary",
    STOCK_SUMMARY_EXPORT: "BackOffice/StockReport/stock-summary/export",
    STOCK_SUMMARY_REPORT: "BackOffice/StockReport/stock-summary-report",
    STOCK_SUMMARY_REPORT_EXPORT: "BackOffice/StockReport/stock-summary-report/export",
    STOCK_VALUATION_REPORT: "BackOffice/StockReport/stock-valuation",
    STOCK_VALUATION_REPORT_EXPORT: "BackOffice/StockReport/stock-valuation/export",
    LOW_STOCK: "BackOffice/StockReport/low-stock",
    LOW_STOCK_EXPORT: "BackOffice/StockReport/low-stock/export",
    STOCK_AGING: "BackOffice/StockReport/stock-aging",
    STOCK_AGING_EXPORT: "BackOffice/StockReport/stock-aging/export",
    BIN_STOCK: "BackOffice/StockReport/bin-stock",
    BIN_STOCK_EXPORT: "BackOffice/StockReport/bin-stock/export",
    STOCK_ADJUSTMENT: "BackOffice/StockReport/stock-adjustment",
    STOCK_ADJUSTMENT_EXPORT: "BackOffice/StockReport/stock-adjustment/export",
  },
  STOCK_LEDGER: {
    LEDGER: "BackOffice/StockLedger/ledger",
    PR_BOX_DETAIL: "BackOffice/StockLedger/pr-box-detail",
    PICKLIST_DETAIL: "BackOffice/StockLedger/picklist-detail",
    INVOICE_DETAIL: "BackOffice/StockLedger/invoice-detail",
    COUNTER_SALE_DETAIL: "BackOffice/StockLedger/counter-sale-detail",
    SALES_RETURN_DETAIL: "BackOffice/StockLedger/sales-return-detail",
    ADJUSTMENT_DETAIL: "BackOffice/StockLedger/adjustment-detail",
    TRANSFER_DETAIL: "BackOffice/StockLedger/transfer-detail",
  },
  PURCHASE_REPORT: {
    PURCHASE_ORDERS: "BackOffice/PurchaseReport/purchase-orders",
    PURCHASE_ORDERS_EXPORT: "BackOffice/PurchaseReport/purchase-orders/export",
    PENDING_POS: "BackOffice/PurchaseReport/pending-purchase-orders",
    PENDING_POS_EXPORT: "BackOffice/PurchaseReport/pending-purchase-orders/export",
    GOODS_RECEIPTS: "BackOffice/PurchaseReport/goods-receipts",
    GOODS_RECEIPTS_EXPORT: "BackOffice/PurchaseReport/goods-receipts/export",
    PURCHASE_VARIANCE: "BackOffice/PurchaseReport/purchase-receipt-variance",
    PURCHASE_VARIANCE_EXPORT: "BackOffice/PurchaseReport/purchase-receipt-variance/export",
    PURCHASE_REGISTER: "BackOffice/PurchaseReport/PurchaseRegister",
    PURCHASE_REGISTER_EXPORT: "BackOffice/PurchaseReport/PurchaseRegister/export",
    PURCHASE_MONTHLY: "BackOffice/PurchaseReport/PurchaseMonthly",
    PURCHASE_MONTHLY_EXPORT: "BackOffice/PurchaseReport/PurchaseMonthly/export",
  },
  SALES_REPORT: {
    SALES_ORDERS: "BackOffice/SalesReport/sales-orders",
    SALES_ORDERS_EXPORT: "BackOffice/SalesReport/sales-orders/export",
    PENDING_SOS: "BackOffice/SalesReport/pending-sales-orders",
    PENDING_SOS_EXPORT: "BackOffice/SalesReport/pending-sales-orders/export",
    BACKORDERS: "BackOffice/SalesReport/backorders",
    BACKORDERS_EXPORT: "BackOffice/SalesReport/backorders/export",
    SALES_BY_CUSTOMER: "BackOffice/SalesReport/SalesByCustomer",
    SALES_BY_CUSTOMER_DETAIL: "BackOffice/SalesReport/SalesByCustomer/detail",
    SALES_BY_CUSTOMER_EXPORT: "BackOffice/SalesReport/SalesByCustomer/export",
    SALES_BY_ITEM: "BackOffice/SalesReport/SalesByItem",
    SALES_BY_ITEM_DETAIL: "BackOffice/SalesReport/SalesByItem/detail",
    SALES_BY_ITEM_EXPORT: "BackOffice/SalesReport/SalesByItem/export",
    SALES_BY_CATEGORY: "BackOffice/SalesReport/SalesByCategory",
    SALES_BY_CATEGORY_DETAIL: "BackOffice/SalesReport/SalesByCategory/detail",
    SALES_BY_CATEGORY_EXPORT: "BackOffice/SalesReport/SalesByCategory/export",
    SALES_BY_CATEGORY_DETAIL_EXPORT: "BackOffice/SalesReport/SalesByCategory/detail/export",
    SALES_BY_BRAND: "BackOffice/SalesReport/SalesByBrand",
    SALES_BY_BRAND_DETAIL: "BackOffice/SalesReport/SalesByBrand/detail",
    SALES_BY_BRAND_EXPORT: "BackOffice/SalesReport/SalesByBrand/export",
    SALES_BY_BRAND_DETAIL_EXPORT: "BackOffice/SalesReport/SalesByBrand/detail/export",
    SALES_BY_INVOICE: "BackOffice/SalesReport/SalesByInvoice",
    SALES_BY_INVOICE_EXPORT: "BackOffice/SalesReport/SalesByInvoice/export",
    SALES_BY_SALES_PERSON: "BackOffice/SalesReport/SalesBySalesPerson",
    SALES_BY_SALES_PERSON_DETAIL: "BackOffice/SalesReport/SalesBySalesPerson/detail",
    SALES_BY_SALES_PERSON_EXPORT: "BackOffice/SalesReport/SalesBySalesPerson/export",
    CUSTOMER_ITEM_SALES: "BackOffice/SalesReport/customer-item-sales",
    CUSTOMER_ITEM_SALES_EXPORT:
      "BackOffice/SalesReport/customer-item-sales/export",
    CUSTOMER_MONTHLY_SALES: "BackOffice/SalesReport/CustomerMonthlySales",
    CUSTOMER_MONTHLY_SALES_EXPORT:
      "BackOffice/SalesReport/CustomerMonthlySales/export",
    NET_SALES_REGISTER: "BackOffice/SalesReport/net-sales-register",
    NET_SALES_REGISTER_EXPORT: "BackOffice/SalesReport/net-sales-register/export",
    BUSINESS_SALES_TRANSACTION: "BackOffice/SalesReport/business-sales-transaction",
    BUSINESS_SALES_TRANSACTION_EXPORT: "BackOffice/SalesReport/business-sales-transaction/export",
    COUNTER_SALES_REPORT: "BackOffice/SalesReport/counterSales",
    COUNTER_SALES_REPORT_EXPORT: "BackOffice/SalesReport/counterSales/export",
    COUNTER_SALES_DETAIL: "BackOffice/SalesReport/counterSales/detail",
    COUNTER_SALES_DETAIL_EXPORT: "BackOffice/SalesReport/counterSales/detail/export",
    SALES_VS_FULFILLMENT_REPORT: "BackOffice/SalesReport/sales-vs-fulfillment",
    SALES_VS_FULFILLMENT_REPORT_EXPORT: "BackOffice/SalesReport/sales-vs-fulfillment/export",
    SALES_VS_FULFILLMENT_DETAIL_EXPORT: "BackOffice/SalesReport/sales-vs-fulfillment/detail/export",
    SALES_VS_FULFILLMENT_DETAILS: (salesOrderId) => `BackOffice/SalesReport/sales-vs-fulfillment/${salesOrderId}/details`,
    SALES_RETURN_AND_RMA: "BackOffice/SalesReport/sales-return-rma",
    SALES_RETURN_AND_RMA_EXPORT: "BackOffice/SalesReport/sales-return-rma/export",
    SALES_RETURN_AND_RMA_DETAIL: "BackOffice/SalesReport/sales-return-rma/detail",
    SALES_RETURN_AND_RMA_DETAIL_EXPORT: "BackOffice/SalesReport/sales-return-rma/detail/export",
  },
  GSTR_REPORT: {
    GSTINS: "BackOffice/GSTRReport/gstins",
    // GSTR-1 section rows; append the section key (b2b, b2cl, b2cs, cdnr, cdnur, doc, hsn, hsnb2b, hsnb2c)
    GSTR1_SECTION: (section) => `BackOffice/GSTRReport/gstr1/${section}`,
    GSTR1_EXPORT: "BackOffice/GSTRReport/gstr1/export",
  },
  INVOICE_REPORT: {
    INVOICES: "BackOffice/InvoiceReport/invoices",
    INVOICES_EXPORT: "BackOffice/InvoiceReport/invoices/export",
    INVOICE_DETAIL_EXPORT: "BackOffice/InvoiceReport/invoices/detail/export",
    OUTSTANDING: "BackOffice/InvoiceReport/outstanding-invoices",
    OUTSTANDING_EXPORT: "BackOffice/InvoiceReport/outstanding-invoices/export",
    AGING: "BackOffice/InvoiceReport/invoice-aging",
    AGING_EXPORT: "BackOffice/InvoiceReport/invoice-aging/export",
  },
  REPORT_EXPORT: {
    HISTORY: "BackOffice/ReportExport/history",
    STATUS: (id) => `BackOffice/ReportExport/${id}/status`,
    DOWNLOAD: (id) => `BackOffice/ReportExport/${id}/download`,
  },
  DISCOUNT_SCHEME: {
    SLUG: "BackOffice/DiscountScheme",
    RESOLVE: "BackOffice/DiscountScheme/Resolve",
  },
  REALTIME: {
    TICKET: "BackOffice/Realtime/ticket",
  },
};

export default API_URL;
